import { render, staticRenderFns } from "./ChangeAffiliation.vue?vue&type=template&id=1dc11ff4&scoped=true&"
import script from "./ChangeAffiliation.vue?vue&type=script&lang=js&"
export * from "./ChangeAffiliation.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAffiliation.vue?vue&type=style&index=0&id=1dc11ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc11ff4",
  null
  
)

export default component.exports